import {
  RetoolEmbedOUT,
  getLocalAuthHeader,
  reportBuildingApi,
  RetoolEmbedIN,
} from "api-client";
import { makeAutoObservable } from "mobx";

class RetoolStore {
  async getEmbedUrl(
    id: string,
    environment?: string,
    releaseVersion?: string
  ): Promise<RetoolEmbedOUT> {
    const authHeader = getLocalAuthHeader();
    const requestConfig: RetoolEmbedIN = {
      app_id: id,
      environment: environment || null,
      release_version: releaseVersion || null,
    };

    const embedded = await reportBuildingApi.reportApiV1RoutersBuildingEmbedUrl(
      requestConfig,
      authHeader
    );

    return embedded.data;
  }

  constructor() {
    makeAutoObservable(this);
  }

  static instance: RetoolStore;
  static getInstance(): RetoolStore {
    if (!RetoolStore.instance) {
      RetoolStore.instance = new RetoolStore();
    }
    return RetoolStore.instance;
  }
}

export const retoolStore = RetoolStore.getInstance();
